import React from 'react';
import { useNavigate } from 'react-router-dom';

const NAV_LINKS = [
  { label: 'Dashboard', path: '/home-dashboard' },
  { label: 'Invest', path: '/investment-opportunities' },
  { label: 'Portfolio', path: '/portfolio-tracker' },
  { label: 'Community', path: '/community-hub' },
  { label: 'Shop', path: '/win-marketplace-products' },
];

export default function NavFallback() {
  const navigate = useNavigate();

  return (
    <div className="mt-8 flex flex-col items-center gap-4">
      <p className="text-sm" style={{ color: 'rgba(255,255,255,0.6)' }}>
        Or navigate to:
      </p>
      <div className="flex flex-wrap justify-center gap-3">
        {NAV_LINKS?.map(link => (
          <button
            key={link?.path}
            onClick={() => navigate(link?.path)}
            className="px-4 py-2 rounded-full text-sm font-medium transition-all duration-200"
            style={{
              border: '1px solid #D4A520',
              color: '#D4A520',
              backgroundColor: 'transparent',
            }}
            onMouseEnter={e => {
              e.currentTarget.style.backgroundColor = '#D4A520';
              e.currentTarget.style.color = '#0B1F3B';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.backgroundColor = 'transparent';
              e.currentTarget.style.color = '#D4A520';
            }}
          >
            {link?.label}
          </button>
        ))}
      </div>
    </div>
  );
}
